enum BreakpointName {
	X_SMALL = 'xsmall',
	SMALL = 'small',
	MEDIUM = 'medium',
	LARGE = 'large',
	X_LARGE = 'xlarge',
}

export default BreakpointName;